module.exports = __webpack_public_path__ + "static/img/HList1.b228f10b.png";